import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URL, PARSE_APPLICATION_ID, PARSE_REST_API_KEY } from "../api";

export const getUsers = createAsyncThunk(
  "admin/getUsers",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url =
        API_URL +
        "/parse/functions/get-users?limit=" +
        payload.pageSize +
        "&skip=" +
        payload.pageNum;
      const user = getState().user.userMe;
      const options = {
        method: "POST",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
        },
      };

      const res = await fetch(url, options);
      const data = await res.json();
      if (data.error) {
        rejectWithValue(res.error);
      }
      return data.result;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getPrizes = createAsyncThunk(
  "admin/getPrizes",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Prize";
      const user = getState().user.userMe;
      const options = {
        method: "GET",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
        },
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = await res.json();
      return data.results;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const deletePrize = createAsyncThunk(
  "admin/deletePrize",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Prize/" + payload.prizeId;
      const user = getState().user.userMe;
      const options = {
        method: "DELETE",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
        },
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = await res.json();
      return data.results;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const addNewPrize = createAsyncThunk(
  "admin/addNewPrize",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Prize";
      const user = getState().user.userMe;
      const options = {
        method: "POST",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: payload.name,
          stock: parseInt(payload.stock),
          points: parseInt(payload.pointsNeeded),
          photo: payload.photo,
          available: payload.available,
        }),
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = await res.json();
      return data.results;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const updatePrize = createAsyncThunk(
  "admin/updatePrize",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Prize/" + payload.objectId;
      const user = getState().user.userMe;
      const options = {
        method: "PUT",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: payload.name,
          stock: parseInt(payload.stock),
          points: parseInt(payload.pointsNeeded),
          photo: payload.photo,
          available: payload.available,
        }),
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = await res.json();
      return data.results;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const getAllUnprocessedReceipts = createAsyncThunk(
  "admin/getAllUnprocessedReceipts",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url =
        API_URL +
        "/parse/functions/get-unprocessed-receipts?limit=" +
        payload.pageSize +
        "&skip=" +
        payload.pageNum;
      const user = getState().user.userMe;
      const options = {
        method: "POST",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
        },
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = await res.json();
      return data.result;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const getAllProcessedReceipts = createAsyncThunk(
  "admin/getAllProcessedReceipts",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url =
        API_URL +
        "/parse/functions/get-processed-receipts?limit=" +
        payload.pageSize +
        "&skip=" +
        payload.pageNum;
      const user = getState().user.userMe;
      const options = {
        method: "POST",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
        },
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = await res.json();
      return data.result;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const getAllReceiptsImages = createAsyncThunk(
  "admin/getAllReceiptsImages",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url =
        API_URL +
        "/classes/Gallery?limit=" +
        payload.pageSize +
        "&skip=" +
        payload.pageNum;
      const user = getState().user.userMe;
      const options = {
        method: "GET",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
        },
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = await res.json();
      return data.results;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const makeReceiptInvalid = createAsyncThunk(
  "admin/makeReceiptInvalid",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Gallery/" + payload.objectId;
      const user = getState().user.userMe;
      const options = {
        method: "PUT",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
        },
        body: JSON.stringify({
          processed: payload.processed,
          valid: payload.valid,
        }),
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = await res.json();
      return data.results;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const makeReceiptProcessed = createAsyncThunk(
  "admin/makeReceiptProcessed",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Gallery/" + payload.objectId;
      const user = getState().user.userMe;
      const options = {
        method: "PUT",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
        },
        body: JSON.stringify({
          processed: payload.processed,
        }),
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = await res.json();
      return data.results;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const togglePrizeAvailability = createAsyncThunk(
  "admin/togglePrizeAvailability",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Prize/" + payload.objectId;
      const user = getState().user.userMe;
      const options = {
        method: "PUT",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
        },
        body: JSON.stringify({
          available: payload.available,
        }),
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = await res.json();
      return data.results;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const makeUserAdmin = createAsyncThunk(
  "admin/makeUserAdmin",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/functions/make-admin";
      const user = getState().user.userMe;
      const options = {
        method: "POST",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
        },
        body: JSON.stringify({
          user: payload.user,
        }),
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = await res.json();
      return data.results;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  getPrizesLoading: "IDLE",
  getPrizesError: null,
  allPrizes: null,
  updatePrizeLoading: "IDLE",
  updatePrizeError: null,
  deletePrizeLoading: "IDLE",
  deletePrizeError: null,
  addNewPrizeLoading: "IDLE",
  addNewPrizeError: null,
  getAllReceiptsImagesLoading: "IDLE",
  getAllReceiptsImagesError: null,
  allReceiptsImages: null,
  makeReceiptInvalidLoading: "IDLE",
  makeReceiptInvalidError: null,
  togglePrizeAvailabilityLoading: "IDLE",
  togglePrizeAvailabilityError: null,
  makeReceiptProcessedLoading: "IDLE",
  makeReceiptProcessedError: null,
  getUsersLoading: "IDLE",
  getUsersError: null,
  allUsers: null,
  totalUsersCount: 0,
  makeUserAdminLoading: "IDLE",
  makeUserAdminError: null,
  getAllUnprocessedReceiptsLoading: "IDLE",
  getAllUnprocessedReceiptsError: null,
  allUnprocessedReceipts: null,
  unProcessedReceiptsCount: 0,

  getAllProcessedReceiptsLoading: "IDLE",
  getAllProcessedReceiptsError: null,
  allProcessedReceipts: null,
  processedReceiptsCount: 0,
};
export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPrizes.pending, (state, action) => {
      state.getPrizesLoading = "PENDING";
      state.getPrizesError = null;
    });
    builder.addCase(getPrizes.fulfilled, (state, action) => {
      state.getPrizesLoading = "SUCCESS";
      state.getPrizesError = null;
      state.allPrizes = action.payload;
    });
    builder.addCase(getPrizes.rejected, (state, action) => {
      state.getPrizesLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.getPrizesError = err;
    });

    builder.addCase(updatePrize.pending, (state, action) => {
      state.updatePrizeLoading = "PENDING";
      state.updatePrizeError = null;
    });
    builder.addCase(updatePrize.fulfilled, (state, action) => {
      state.updatePrizeLoading = "SUCCESS";
      state.updatePrizeError = null;
    });
    builder.addCase(updatePrize.rejected, (state, action) => {
      state.updatePrizeLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.updatePrizeError = err;
    });

    builder.addCase(deletePrize.pending, (state, action) => {
      state.deletePrizeLoading = "PENDING";
      state.deletePrizeError = null;
    });
    builder.addCase(deletePrize.fulfilled, (state, action) => {
      state.deletePrizeLoading = "SUCCESS";
      state.deletePrizeError = null;
    });
    builder.addCase(deletePrize.rejected, (state, action) => {
      state.deletePrizeLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.deletePrizeError = err;
    });

    builder.addCase(addNewPrize.pending, (state, action) => {
      state.addNewPrizeLoading = "PENDING";
      state.addNewPrizeError = null;
    });
    builder.addCase(addNewPrize.fulfilled, (state, action) => {
      state.addNewPrizeLoading = "SUCCESS";
      state.addNewPrizeError = null;
    });
    builder.addCase(addNewPrize.rejected, (state, action) => {
      state.addNewPrizeLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.addNewPrizeError = err;
    });

    builder.addCase(getAllReceiptsImages.pending, (state, action) => {
      state.getAllReceiptsImagesLoading = "PENDING";
      state.getAllReceiptsImagesError = null;
    });
    builder.addCase(getAllReceiptsImages.fulfilled, (state, action) => {
      state.getAllReceiptsImagesLoading = "SUCCESS";
      state.getAllReceiptsImagesError = null;
      state.allReceiptsImages = action.payload;
    });
    builder.addCase(getAllReceiptsImages.rejected, (state, action) => {
      state.getAllReceiptsImagesLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.getAllReceiptsImagesError = err;
    });

    builder.addCase(makeReceiptInvalid.pending, (state, action) => {
      state.makeReceiptInvalidLoading = "PENDING";
      state.makeReceiptInvalidError = null;
    });
    builder.addCase(makeReceiptInvalid.fulfilled, (state, action) => {
      state.makeReceiptInvalidLoading = "SUCCESS";
      state.makeReceiptInvalidError = null;
    });
    builder.addCase(makeReceiptInvalid.rejected, (state, action) => {
      state.makeReceiptInvalidLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.makeReceiptInvalidError = err;
    });

    builder.addCase(togglePrizeAvailability.pending, (state, action) => {
      state.togglePrizeAvailabilityLoading = "PENDING";
      state.togglePrizeAvailabilityError = null;
    });
    builder.addCase(togglePrizeAvailability.fulfilled, (state, action) => {
      state.togglePrizeAvailabilityLoading = "SUCCESS";
      state.togglePrizeAvailabilityError = null;
    });
    builder.addCase(togglePrizeAvailability.rejected, (state, action) => {
      state.togglePrizeAvailabilityLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.togglePrizeAvailabilityError = err;
    });

    builder.addCase(makeReceiptProcessed.pending, (state, action) => {
      state.makeReceiptProcessedLoading = "PENDING";
      state.makeReceiptProcessedError = null;
    });
    builder.addCase(makeReceiptProcessed.fulfilled, (state, action) => {
      state.makeReceiptProcessedLoading = "SUCCESS";
      state.makeReceiptProcessedError = null;
    });
    builder.addCase(makeReceiptProcessed.rejected, (state, action) => {
      state.makeReceiptProcessedLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.makeReceiptProcessedError = err;
    });

    builder.addCase(getUsers.pending, (state, action) => {
      state.getUsersLoading = "PENDING";
      state.getUsersError = null;
    });
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.getUsersLoading = "SUCCESS";
      state.getUsersError = null;
      state.allUsers = action.payload.users;
      state.totalUsersCount = action.payload.count;
    });
    builder.addCase(getUsers.rejected, (state, action) => {
      state.getUsersLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.getUsersError = err;
    });

    

    builder.addCase(makeUserAdmin.pending, (state, action) => {
      state.makeUserAdminLoading = "PENDING";
      state.makeUserAdminError = null;
    });
    builder.addCase(makeUserAdmin.fulfilled, (state, action) => {
      state.makeUserAdminLoading = "SUCCESS";
      state.makeUserAdminError = null;
    });
    builder.addCase(makeUserAdmin.rejected, (state, action) => {
      state.makeUserAdminLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.makeUserAdminError = err;
    });

    builder.addCase(getAllUnprocessedReceipts.pending, (state, action) => {
      state.getAllUnprocessedReceiptsLoading = "PENDING";
      state.getAllUnprocessedReceiptsError = null;
    });
    builder.addCase(getAllUnprocessedReceipts.fulfilled, (state, action) => {
      state.getAllUnprocessedReceiptsLoading = "SUCCESS";
      state.getAllUnprocessedReceiptsError = null;
      state.allUnprocessedReceipts = action.payload.receipts;
      state.unProcessedReceiptsCount = action.payload.count
    });
    builder.addCase(getAllUnprocessedReceipts.rejected, (state, action) => {
      state.getAllUnprocessedReceiptsLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.getAllUnprocessedReceiptsError = err;
    });

    builder.addCase(getAllProcessedReceipts.pending, (state, action) => {
      state.getAllProcessedReceiptsLoading = "PENDING";
      state.getAllProcessedReceiptsError = null;
    });
    builder.addCase(getAllProcessedReceipts.fulfilled, (state, action) => {
      state.getAllProcessedReceiptsLoading = "SUCCESS";
      state.getAllProcessedReceiptsError = null;
      state.allProcessedReceipts = action.payload.receipts;
      state.processedReceiptsCount = action.payload.count
    });
    builder.addCase(getAllProcessedReceipts.rejected, (state, action) => {
      state.getAllProcessedReceiptsLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.getAllProcessedReceiptsError = err;
    });

  
  
  },
});

// this is for dispatch
export const {} = adminSlice.actions;

// this is for configureStore
export default adminSlice.reducer;
